<div class="header">
  <h2 class="titulo">Alterar Status</h2>
  <button mat-icon-button (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="linha-divisoria"></div>

<form [formGroup]="form" class="form-container" novalidate>
  <div class="linha-campos">
    <mat-form-field appearance="outline" class="campo">
      <mat-label>Novo Status</mat-label>
      <mat-select formControlName="status" required>
        @for (s of statusLeadList; track $index) {
          <mat-option [value]="s.id">
            {{ s.nome }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <app-datetime-picker formControlName="retorno" placeholder="Retornar contato em">
    </app-datetime-picker>
  </div>

  <mat-form-field appearance="outline" class="campo-texto">
    <mat-label>Observações do contato</mat-label>
    <textarea matInput rows="6" formControlName="observacoes" maxlength="240"></textarea>
    <mat-hint align="start">{{ form.get('observacoes')?.value?.length || 0 }}/240</mat-hint>
  </mat-form-field>

  <div class="botoes">
    <!-- Botão ATUALIZAR (normal) -->
    <button
      mat-stroked-button
      class="btn-outline"
      type="button"
      (click)="atualizar()"
      [disabled]="loading"
    >
      @if (loading && action === 'atualizar') {
        <mat-progress-spinner diameter="20" mode="indeterminate" class="spinner" />
      }

      @if (!(loading && action === 'atualizar')) {
        <span>Atualizar</span>
      }
    </button>
  </div>
</form>

@if (loading) {
  <!-- 🔒 Overlay global de bloqueio -->
  <div class="ui-blocker">
    <mat-progress-spinner diameter="50" mode="indeterminate" />
  </div>
}
